import React, { createContext, useContext, useState, useEffect } from 'react';
import { CircularProgress, Box } from '@mui/material';

let activeRequests = 0;
let setActiveRequestsCallback = null;

const LoadingContext = createContext({
  activeRequests: 0,
  startLoading: () => { },
  stopLoading: () => { },
});

// Hook to access loading state
export const useLoading = () => useContext(LoadingContext);

export const startLoading = () => {
  activeRequests += 1;
  if (setActiveRequestsCallback) { setActiveRequestsCallback(activeRequests); }
};

export const stopLoading = () => {
  activeRequests = Math.max(0, activeRequests - 1); // Prevent negative counts
  if (setActiveRequestsCallback) { setActiveRequestsCallback(activeRequests); }
};

// Loading indicator component
const LoadingIndicator = ({ activeRequests }) => {
  if (activeRequests === 0) {
    return null;
  } else {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 10000,
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }
};

// Provider to sync React state with singleton counter
export const LoadingProvider = ({ children }) => {
  const [reactActiveRequests, setReactActiveRequests] = useState(activeRequests);

  useEffect(() => {
    setActiveRequestsCallback = setReactActiveRequests;
    setReactActiveRequests(activeRequests); // Initial sync
    return () => {
      setActiveRequestsCallback = null; // Cleanup
    };
  }, []);

  return (
    <LoadingContext.Provider
      value={{
        activeRequests: reactActiveRequests,
        startLoading,
        stopLoading,
      }}
    >
      <LoadingIndicator activeRequests={reactActiveRequests} />
      {children}
    </LoadingContext.Provider>
  );
};